export function toMinutes(value, unit) {
  if (value === "" || value === null || value === undefined) {
    return "";
  }

  const numericValue = Number(value);
  if (!Number.isFinite(numericValue)) {
    return "";
  }

  return unit === "hr" ? Math.round(numericValue * 60) : Math.round(numericValue);
}

export function deriveUniformTimeFields(prepMinutes, cookMinutes) {
  const prep = normalizeMinutes(prepMinutes);
  const cook = normalizeMinutes(cookMinutes);
  const useHours = prep && cook && prep % 60 === 0 && cook % 60 === 0;

  if (useHours) {
    return {
      prep_time_value: String(prep / 60),
      prep_time_unit: "hr",
      cook_time_value: String(cook / 60),
      cook_time_unit: "hr",
    };
  }

  return {
    prep_time_value: prep === "" ? "" : String(prep),
    prep_time_unit: "min",
    cook_time_value: cook === "" ? "" : String(cook),
    cook_time_unit: "min",
  };
}

function normalizeMinutes(value) {
  if (value === "" || value === null || value === undefined) {
    return "";
  }

  const numericValue = Number(value);
  if (!Number.isFinite(numericValue)) {
    return "";
  }

  return numericValue;
}
